import { localisedValue } from "utils"

const sharingTypeTransformer = response => {
  return response?.map(item => ({
    ...item,
    value: item?.id?.toString(),
    label: localisedValue({ object: item, key: "title" }),
  }))
}

export default sharingTypeTransformer
